import cn from 'classnames';
import { useLayoutEffect, useState } from 'react';
import { AnswerID, QuestionStr } from '../../../types';
import s from './SQ.module.scss';
interface Props {
    q: QuestionStr;
    isTimed: boolean;
    showSolution: boolean;
    isQuiz?: boolean;
    onAnswerSelectCallback: (
        isRight: boolean,
        selected_ans_id: AnswerID
    ) => void;
}
const SingleQuestion = ({
    q,
    isTimed,
    showSolution,
    onAnswerSelectCallback,
    isQuiz = true,
}: Props) => {
    const [selectedAns, setSelectedAns] = useState<number>();
    const onAnsSlelect = (id: AnswerID) => {
        if (isQuiz && !selectedAns && !isTimed) {
            setSelectedAns(id);
            const isRight = q.answers[id - 1].is_right ? true : false;
            setIsSelectedRight(isRight);
            onAnswerSelectCallback(isRight, id);
        }
    };
    const [isSelectedRight, setIsSelectedRight] = useState<boolean>();

    useLayoutEffect(() => {
        setSelectedAns(undefined);
        setIsSelectedRight(undefined);
    }, [q]);
    //q.status !== undefined
    return (
        <div className={s.q}>
            <div className={s.q_wrap_cont}>
                <div
                    className={`sun-editor-editable se-rtl ${s.q_cont} ims`}
                    dangerouslySetInnerHTML={{ __html: q.content }}
                />
                {/* <SvgMoreHighliter /> */}
            </div>

            <div
                className={cn(s.q_answers, {
                    [s.q_answers_1x4]: q.ans_layout === '1x4',
                    [s.q_answers_2x2]: q.ans_layout === '2x2',
                    [s.q_answers_4x1]: q.ans_layout === '4x1',
                })}
            >
                {q.answers.map((a, ind) => {
                    const aid = parseInt(a.id) as AnswerID;

                    return (
                        <button
                            className={cn(s.q_ans, {
                                [s.q_ans_right]:
                                    (selectedAns && a.is_right) ||
                                    (q.selected_ans_id && a.is_right === '1'),
                                [s.q_ans_wrong]:
                                    (aid === selectedAns && !isSelectedRight) ||
                                    (q.selected_ans_id &&
                                        q.selected_ans_id === aid &&
                                        !q.answers[ind].is_right),
                                [s.q_ans_right_timed]:
                                    (isTimed &&
                                        q.status !== undefined &&
                                        a.is_right) ||
                                    (q.selected_ans_id &&
                                        q.status === 2 &&
                                        a.is_right),
                            })}
                            onClick={() => onAnsSlelect(aid)}
                            key={`ans${a.id}`}
                        >
                            <div className={s.q_ans_ind}>{a.id}</div>
                            <div
                                className={`sun-editor-editable se-rtl ${s.q_ans_cont}`}
                                dangerouslySetInnerHTML={{
                                    __html: a.content,
                                }}
                            ></div>
                        </button>
                    );
                })}
            </div>
            {showSolution && (
                <>
                    <h3 className={s.sol_title}>פתרון</h3>

                    <div
                        className={`sun-editor-editable se-rtl ${s.solu} ims`}
                        dangerouslySetInnerHTML={{ __html: q.solution }}
                    />
                </>
            )}
        </div>
    );
};
export default SingleQuestion;
